<template>
  <div class="image-card">
    <el-image :src="file.url" :preview-src-list="images.map(im => im.url)" />
    <div class="image-card__name">{{file.fileName}}</div>
    <span v-if="isEdited" class="image-card__close" @click="onRemove">
      <i class="el-icon-close" />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    isEdited: {
      type: Boolean,
      required: true,
    },
    file: {
      type: Object,
    },
    images: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onRemove() {
      this.$emit('onRemove', this.file);
    },
  },

};
</script>
